/**
 * Created by sungho.hong on 2019-10-12.
 */

export default {
    env : ""
}




// WEBPACK FOOTER //
// ./src/components/common/profile.js